import React from 'react';

import { Box, Typography } from '@mui/material';

import { parseNullableValue } from '@hrlogics/helper-utils';

import { DateFormatPatterns } from '@clearverify/constants';
import { formatDate } from '@clearverify/utils';

import { type EmployeeNoteInfoFragment } from 'src/api';
import type { SxProp } from 'src/types/mui';

type EmployeeDataInternalNotesCardItemProps = {
  employeeNote: EmployeeNoteInfoFragment;
};

export const EmployeeDataInternalNotesCardItem: React.FC<
  EmployeeDataInternalNotesCardItemProps
> = ({ employeeNote }) => (
  <Box sx={employeeNoteStyles}>
    <Typography variant="caption" color="text.secondary">
      {employeeNote.createdBy} —{' '}
      {formatDate(employeeNote.createdAt, DateFormatPatterns.meridiemTimePaddedWithDate)}
    </Typography>
    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
      {parseNullableValue(employeeNote.comment)}
    </Typography>
  </Box>
);

const employeeNoteStyles: SxProp = theme => ({
  paddingX: 2,
  paddingY: 1,
  backgroundColor: theme.palette.grey[200],
  borderRadius: '10px',

  '&:not(:first-child)': {
    marginTop: 1,
  },
});
